import React from 'react'
import { observer } from 'mobx-react-lite'
import BrowseProvider from '../../contexts/BrowseContext'
import CampaignsSidebar from './Campaigns/CampaignsSidebar'
import CampaignsHeader from './Campaigns/CampaignsHeader'
import CampaignsIndex from './Campaigns/CampaignsIndex'
import ArchiveIndex from './Campaigns/ArchiveIndex'
import { useParams } from 'react-router-dom'


export default observer(function Campaigns({ archived = false }) {
  const { client_id, folder_id } = useParams()
  const isClientPage = client_id && !folder_id

  return (
    <div>
      <BrowseProvider>
        <CampaignsSidebar/>
        {archived ? (
          <ArchiveIndex />
        ) : (
          <>
            {!isClientPage && <CampaignsHeader />}
            <CampaignsIndex/>
          </>
        )}
      </BrowseProvider>
    </div>
  )
})
